// libs
import { writable } from "svelte/store";

// types
import type { PaymentTransferType } from "@shared/types/Invoice";

// baseline invoice data state
export interface PaymentsData {
  transfers: PaymentTransferType[],
  loaded: boolean,
  failed: boolean,
  filters: {
    searchValue: string,
    status: string,
    startDate: string,
    endDate: string,
  }
  pagination?: {
    page: number,
    perPage: number,
    totalEntries: number,
  },
};

// data
const paginationInitialState = {
  page: 1,
  perPage: 15,
  totalEntries: 0,
};
const initialState = {
  transfers: [],
  loaded: false,
  failed: false,
  filters: {
    searchValue: "",
    status: null,
    startDate: "",
    endDate: "",
  },
  pagination: paginationInitialState,
};

export const PaymentsStore = writable<PaymentsData>(initialState);

// functions
export const reset = () => {
  PaymentsStore.update(state => ({
    ...state,
    transfers: [],
  }))
};
